import * as actionTypes from "../actions/actionTypes";

const initialState: {} = {
  accessTokenParsed: false,
  parseAccessTokenLoading: false,
  error: false,
};
const appConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PARSE_ACCESS_TOKEN_SUCCESS: {
      return {
        ...state,
        accessTokenParsed: true,
        error: false,
        parseAccessTokenLoading: false,
      };
    }
    case actionTypes.PARSE_ACCESS_TOKEN_STARTED: {
      return {
        ...state,
        accessTokenParsed: false,
        error: false,
        parseAccessTokenLoading: true,
      };
    }
    case actionTypes.FETCH_APP_CONFIG_STARTED: {
      return {
        ...state,
        appConfig: null,
        error: false,
        loading: true,
      };
    }
    default:
      return state;
  }
};
export default appConfigReducer;
